<template>
    <div v-if="has_permission('Dashboards')" class="mb-5">
        <DashboardTop/>
<!--        <CCard>-->

                <CRow >

                    <CCol col="6" style="padding-inline-end: 3px;" >
                        <CCard style="margin-bottom: 3px;">

                        <barChart chart_id="sale_amount" :label="$t('MonthlySalesReport')" bar-color="#3399FF"
                                  style="height:200px;margin-top:5px;"
                                  :chart_datas="sale_amount"/>
                    </CCard>

                    </CCol>

                    <CCol col="6"  style="padding-inline-start: 3px;" >
<!--                        <CCard style="margin-bottom: 3px;">-->

<!--&lt;!&ndash;                        <DonatChart label="Popular Products" bar-color="#f9b115"&ndash;&gt;-->
<!--&lt;!&ndash;                                    style="height:200px;margin-top:5px;" :chart_datas="sale_products"/>&ndash;&gt;-->
<!--&lt;!&ndash;                            <CustomDoghnut/>&ndash;&gt;-->
<!--                            <CustomDonutChart-->
<!--                                    bar-color="#f9b115"-->
<!--                                    :label="$t('sales')"-->
<!--                                              style="height:200px;margin-top:5px;"-->
<!--                                    :chart_datas="top_products_percent"-->
<!--                            />-->
<!--                        </CCard>-->
                        <CCard style="margin-bottom: 3px">
                            <!--                                    <DonatChart label="Cash" bar-color="#f9b115"-->
                            <!--                                                style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_amount_percent"/>-->

                            <CustomDonutChart
                                    :label="$t('TypeOfPayment')" bar-color="#f9b115"
                                    style="height:200px;margin-top:5px;" :chart_datas="cash_delivery_amount_percent"
                            />
                        </CCard>

                    </CCol>
                </CRow>
                <CRow>

                    <CCol col="6"  style="padding-inline-end: 3px;" >
                        <CCard style="margin-bottom: 3px;">

                        <barChart chart_id="sale_amount" :label="$t('chequesPayable')" bar-color="#3399FF"
                                  style="height:200px;margin-top:5px;"
                                  :chart_datas="payable_amount"/>
                        </CCard>

                    </CCol>

                    <CCol col="6"  style="padding-inline-start: 3px;" >
                        <CCard style="margin-bottom: 3px;">

                        <barChart :label="$t('DebtorsAgeingAnalysisReport')" bar-color="#f9b115"
                                  chart_id="profit_loss_1"

                                  style="height:200px;margin-top:5px;" :chart_datas="profit_loss_bar"/>
                        </CCard>

                    </CCol>
                </CRow>

<!--        </CCard>-->
    </div>
</template>

<script>
import MainSaleChart from '../dashboard/MainSaleChart'
import barChart from "../panel/dashboardCharts/barChart";
import DonatChart from "../panel/dashboardCharts/DonatChart";
import WidgetsDropdown from '../widgets/WidgetsDropdown'
import WidgetsBrand from '../widgets/WidgetsBrand'
import DashboardTop from "@/views/dashboard/DashboardTop";
import {bus} from "../../main";
import CustomDonutChart from "../charts/CustomDonutChart";
import axios from "axios";
    export default {
        name: 'Dashboard',
        components: {
          DashboardTop,
            MainSaleChart,
            barChart,
            DonatChart,
            WidgetsDropdown,
            WidgetsBrand,
            CustomDonutChart
        },
        data() {
            return {
                selected_tab: 1,
                selected: 'Month',
                system_report: [],
                productQty: '',
                selected_chart: 1,
                salesQty: '',
                customerQty: '',
                purchaseQty: '',
                chartInfos: [],
                qtyInfos: [],
                sale_qty: [],
                sale_amount: [],
                payable_amount: [],
                sale_products: [],
                sale_category: [],
                buy_qty: [],
                buy_amount: [],
                buy_products: [],
                buy_category: [],
                sale_chart_report: {},
                sale_customers_qty_report: [],
                sale_customers_amount_report: [],
                buy_customers_qty_report: [],
                buy_customers_amount_report: [],
                profit_loss_bar: [],
                profit_loss_donat: [],
                cash_delivery_amount: [],
                cash_delivery_amount_percent: [],
                cash_delivery_qty: [],
                cash_delivery_qty_percent: [],
                top_products_percent: [],

            }
        },
        computed: {
            donat_data_set() {
                return [
                    {label: 'sale', count: '90', color: '#3399ff'},
                    {label: 'revenue', count: '32', color: '#E46651'},
                    {label: 'purchase', count: '65', color: '#00D8FF'},
                    {label: 'customers', count: '85', color: '#DD1B16'},
                ]
            }
        },
        mounted() {
            bus.$on('dashboard_chart_selected', (data) => {
                // alert(data);
                this.selected_chart = data;
            });
            // bus.$emit("show_spinner", 'false');
            // this.get_dashboard_data();
            // this.get_sale_data(1);
            // this.get_sale_data(3);
            // this.get_sale_amount(1);
            this.get_sale_amount(3);
            this.get_payable_amount();
            this.get_top_product_percent();
            this.get_sale_items_data(3);
            // this.get_sale_items_data(1);
            //
            // this.get_sale_category_data(3);
            // this.get_sale_category_data(1);
            //
            // this.get_customers_qty_report(1);
            // this.get_customers_qty_report(3);
            //
            // this.get_customers_amount_report(1);
            // this.get_customers_amount_report(3);
            //
            this.profit_loss_report();
            this.get_sale_cash_delivery(3);


        },
        methods: {
            get_dashboard_data() {

                var self = this;

                const formData = new FormData();

                axios.post('GetSystemReport', formData, {}).then(function (response) {


                    self.productQty = response.data.data.productQty.toString()
                    self.customerQty = response.data.data.customerQty.toString()
                    self.salesQty = response.data.data.salesQty.toString()
                    self.purchaseQty = response.data.data.purchaseQty.toString()

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_sale_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetSalePurQty', formData, {}).then(function (response) {
                    if (type == 1) {
                        self.buy_qty = [];
                        response.data.data.forEach(function (val) {
                            self.buy_qty.push({
                                qty: val.qty,
                                label: self.get_month_by_number(val.title)
                            })
                        })
                    }

                    if (type == 3) {
                        self.sale_qty = [];
                        response.data.data.forEach(function (val) {
                            self.sale_qty.push({
                                qty: val.qty,
                                label: self.get_month_by_number(val.title)
                            })
                        })

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_sale_amount(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetSalePurAmount', formData, {}).then(function (response) {
                    var dat = response.data.data.sort((a, b) => a.qty.toString().localeCompare(b.qty.toString(), undefined, {numeric: true, sensitivity: 'base'}));

                    if (type == 1) {
                        self.buy_amount = [];

                        dat.forEach(function (val) {
                            self.buy_amount.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                    if (type == 3) {
                        self.sale_amount = [];

                        dat.forEach(function (val) {
                            self.sale_amount.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_payable_amount() {
                var self = this;

                const formData = new FormData();
                axios.post('GetAccountPayableAmount', formData, {}).then(function (response) {
                    var dat = response.data.data.sort((a, b) => a.title.localeCompare(b.title, undefined, {numeric: true, sensitivity: 'base'}));

                        self.payable_amount = [];

                        dat.forEach(function (val) {
                          if(val.title==0){
                            self.payable_amount.push({
                              qty: Math.abs(val.amount),
                              label:self.$t('LastYear')
                            })
                          }else if(val.title==13){
                            self.payable_amount.push({
                              qty: Math.abs(val.amount),
                              label:self.$t('NextYear')
                            })
                          }else{
                            self.payable_amount.push({
                              qty: Math.abs(val.amount),
                              label: self.get_month_by_number(val.title)
                            })
                          }

                        })


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            get_sale_items_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomerProducts', formData, {}).then(function (response) {
                    if (type == 3) {
                        self.sale_products = [];
                        var color_arr = ['#3399ff','#E46651','#e48720','#5ae400','#0e69e4']
                        response.data.data.sort((a, b) => b.amount.toString().localeCompare(a.amount.toString(), undefined, {numeric: true, sensitivity: 'base'}));

                        response.data.data.forEach(function (val,index) {
                            if(index<5){
                                self.sale_products.push({
                                    count: parseInt(val.amount),
                                    label: val.title,
                                    color:color_arr[index]
                                })
                            }

                        })
                    }
                    if (type == 1) {
                        self.buy_products = [];

                        response.data.data.forEach(function (val) {
                            self.buy_products.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_top_product_percent() {
                var self = this;

                const formData = new FormData();
                formData.append('id', 3);

                axios.post('GetTopProductsPercent', formData, {}).then(function (response) {
                        self.sale_products = [];
                        var color_arr = ['#3399ff','#e48720','#E46651','#5ae400','#0e69e4']
                        response.data.data.sort((a, b) => b.amount.toString().localeCompare(a.amount.toString(), undefined, {numeric: true, sensitivity: 'base'}));

                        response.data.data.forEach(function (val,index) {
                                self.top_products_percent.push({
                                    count: self.get_percent(val.amount,self.calculate_items(response.data.data,'amount')),
                                    label: val.title,
                                    color:color_arr[index]
                                })
                        })
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_sale_category_data(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomerCategory', formData, {}).then(function (response) {
                    self.sale_chart_report = response.data.data
                    if (type == 3) {
                        self.sale_category = [];

                        response.data.data.forEach(function (val) {
                            self.sale_category.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                    if (type == 1) {
                        self.buy_category = [];

                        response.data.data.forEach(function (val) {
                            self.buy_category.push({
                                qty: val.amount,
                                label: val.title
                            })
                        })
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_customers_qty_report(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomers', formData, {}).then(function (response) {
                    if (type == 1) {
                        self.buy_customers_qty_report = [];
                        response.data.data.forEach(function (val) {

                            self.buy_customers_qty_report.push({
                                qty: val.qty,
                                label: (val.title)
                            })
                        })

                    }
                    if (type == 3) {
                        self.sale_customers_qty_report = [];
                        response.data.data.forEach(function (val) {

                            self.sale_customers_qty_report.push({
                                qty: val.qty,
                                label: (val.title)
                            })
                        })

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_customers_amount_report(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetTopSaleCustomersAmnt', formData, {}).then(function (response) {
                    if (type == 1) {
                        self.buy_customers_amount_report = [];

                        response.data.data.forEach(function (val) {
                            self.buy_customers_amount_report.push({
                                qty: val.amount,
                                label: (val.title)
                            })
                        })

                    }
                    if (type == 3) {
                        self.sale_customers_amount_report = [];

                        response.data.data.forEach(function (val) {
                            self.sale_customers_amount_report.push({
                                qty: val.amount,
                                label: (val.title)
                            })
                        })

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_sale_cash_delivery(type) {
                var self = this;

                const formData = new FormData();
                formData.append('id', type);
                axios.post('GetCashDeliveryRpt', formData, {}).then(function (response) {
                    var res = response.data.data;
                    self.cash_delivery_amount = [{label:'Cash',qty:res.cash},{label:'Credit',qty:res.credit},{label:'Total',qty:res.cash+res.credit}]
                    // self.cash_delivery_amount_percent = [{label: 'Cash', count:res.cash, color: '#3399ff'},
                    //     {label: 'Credit', count: res.credit, color: '#E46651'}]

                    self.cash_delivery_amount_percent = [{label: 'Cash', count:self.get_percent(res.cash,res.cash+res.credit), color: '#3399ff'},
                        {label: 'Credit', count: self.get_percent(res.credit,res.cash+res.credit), color: '#E46651'}]

                    self.cash_delivery_qty = [{label:'Collection',qty:res.collection},{label:'Delivery',qty:res.delivery},{label:'Total',qty:res.collection+res.delivery}]
                    self.cash_delivery_qty_percent = [{label: 'Collection', count:res.collection, color: '#3399ff'},
                        {label: 'Delivery', count: res.delivery, color: '#E46651'}]
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_percent(input,sum){
                if(sum==0||input==0){
                    return 0;
                }
                var per = input*100;
                return (per/sum).toFixed(1);
            },
            profit_loss_report() {
                var self = this;


                const formData = new FormData();

                var url = "GetCredDeptRpt";

                formData.append('CityId', 0);
                formData.append('ProvinceId', 0);
                formData.append('RegionId', 0);
                formData.append('AreaId', 0);
                formData.append('RouteId', 0);
                formData.append('CountryId', 0);
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var profit_items = content_data.data;
                        profit_items.forEach(function (val) {
                            val.before_90 = val.balance90
                            if (val.before_90 < 0) {
                                val.before_90 = 0;
                            }
                            val.before_60 = val.balance60
                            if (val.before_60 < 0) {
                                val.before_60 = 0;
                            }
                            val.before_30 = val.balance30
                            if (val.before_30 < 0) {
                                val.before_30 = 0;
                            }
                            val.before_current = val.currentDays
                            if (val.before_current < 0) {
                                val.before_current = 0;
                            }
                            val.before_120 = val.balanceCurrent - (val.before_current + val.before_30 + val.before_60 + val.before_90)

                        })
                        var before_120 =(self.calculate_items(profit_items, "before_120"))
                        var before_90 = (self.calculate_items(profit_items, "before_90"))
                        var before_60 = (self.calculate_items(profit_items, "before_60"))
                        var before_30 = (self.calculate_items(profit_items, "before_30"))
                        var before_current = (self.calculate_items(profit_items, "before_current"))
                        var before_balance = (self.calculate_items(profit_items, "balanceCurrent"))

                        self.profit_loss_bar = [];
                        self.profit_loss_bar.push({label: '120 ' + self.$t('days'), qty: Math.abs(before_120)})
                        self.profit_loss_bar.push({label: '90 ' + self.$t('days'), qty: Math.abs(before_90)})
                        self.profit_loss_bar.push({label: '60 ' + self.$t('days'), qty: Math.abs(before_60)})
                        self.profit_loss_bar.push({label: '30 ' + self.$t('days'), qty: Math.abs(before_30)})
                        self.profit_loss_bar.push({label: self.$t('current'), qty: Math.abs(before_current)})
                        self.profit_loss_bar.push({label: self.$t('tables.balance'), qty: Math.abs(before_balance)})
                 self.profit_loss_bar.reverse()
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_month_by_number(number) {
                number = parseInt(number);
                if (this.$i18n.locale == 'fa') {
                    switch (number) {
                        case 1:
                            return "فروردین";
                        case 2:
                            return "اردیبهشت";
                        case 3:
                            return "خرداد";
                        case 4:
                            return "تیر";
                        case 5:
                            return "مرداد";
                        case 6:
                            return "شهریور";
                        case 7:
                            return "مهر";
                        case 8:
                            return "آبان";
                        case 9:
                            return "آذر";
                        case 10:
                            return "دی";
                        case 11:
                            return "بهمن";
                        case 12:
                            return "اسفند";

                    }
                } else {
                    switch (number) {
                        case 1:
                            return "Jan";
                        case 2:
                            return "Feb";
                        case 3:
                            return "Mar";
                        case 4:
                            return "Apr";
                        case 5:
                            return "May";
                        case 6:
                            return "Jun";
                        case 7:
                            return "Jul";
                        case 8:
                            return "Aug";
                        case 9:
                            return "Sep";
                        case 10:
                            return "Oct";
                        case 11:
                            return "Nov";
                        case 12:
                            return "Dec";

                    }
                }
            }

        },
    }
</script>
<style>
    .bg-revenue .nav-link.active {
        background: #3399FF;
        color: white;
    }

    .bg-sale .nav-link.active {
        background: #f9b115;
        color: white;
    }

    .bg-profit .nav-link.active {
        background: #2eb85c;
        color: white;
    }
</style>
